import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const configNode = document.getElementById('inc-cart-gift-config');
const config = configNode ? JSON.parse(configNode.textContent) : null;
if (config?.variantId) {
  const root = window.Shopify?.routes?.root || '/';
  const shirts = new Set((config.productIds || []).map(String));
  const choiceKey = 'inc_optional_ebook_selected';
  let selected = sessionStorage.getItem(choiceKey) === 'yes';
  let running = false;
  let pending = false;
  let ownEvent = false;

  async function request(path, data) {
    const response = await fetch(root + path, {
      method: data ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(data ? { body: JSON.stringify(data) } : {}),
    });
    const result = await response.json();
    if (!response.ok || result.status || result.errors)
      throw new Error(result.description || 'Não foi possível atualizar a oferta.');
    return result;
  }

  function syncControls(cart, busy = false) {
    const count = cart.items.reduce((sum, line) =>
      sum + (shirts.has(String(line.product_id)) ? line.quantity : 0), 0);
    const eligible = count >= 2;
    const giftInCart = cart.items.some(item => String(item.variant_id) === String(config.variantId));
    document.querySelectorAll('[data-inc-gift-offer]').forEach(offer => {
      const toggle = offer.querySelector('[data-inc-gift-toggle]');
      const status = offer.querySelector('[data-inc-gift-status]');
      if (!toggle) return;
      toggle.disabled = !eligible || busy;
      toggle.checked = eligible && selected && giftInCart;
      if (status) status.textContent = !eligible
        ? 'Compra 2 t-shirts para desbloquear'
        : busy ? 'A atualizar o presente...'
        : giftInCart && selected ? 'Presente adicionado ao carrinho'
        : 'Ativa para receber com 2 t-shirts';
    });
  }

  async function reconcile() {
    pending = true;
    if (running) return;
    running = true;
    try {
      while (pending) {
        pending = false;
        const cart = await request('cart.js');
        const count = cart.items.reduce((sum, item) =>
          sum + (shirts.has(String(item.product_id)) ? item.quantity : 0), 0);
        const eligible = count >= 2;
        const gifts = cart.items.filter(item => String(item.variant_id) === String(config.variantId));
        const wanted = eligible && selected ? 1 : 0;
        syncControls(cart, true);
        const ids = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map(el => el.dataset.sectionId))].slice(0, 5);
        const sections = { sections: ids.join(','), sections_url: window.location.pathname };
        let result;
        if (wanted && gifts.length === 0) {
          result = await request('cart/add.js', {
            items: [{ id: config.variantId, quantity: 1, properties: {
              '_inc_gift': 'two-shirts', 'Oferta': 'Grátis com 2 t-shirts',
            } }], ...sections,
          });
        } else if (gifts.some((gift, index) => gift.quantity !== (index === 0 ? wanted : 0))) {
          const updates = Object.fromEntries(gifts.map((gift, index) =>
            [gift.key, index === 0 ? wanted : 0]));
          result = await request('cart/update.js', { updates, ...sections });
        }
        if (result) {
          const updated = await request('cart.js');
          ownEvent = true;
          document.dispatchEvent(new CartLinesUpdateEvent({
            action: 'update',
            context: 'cart',
            promise: Promise.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(updated),
              detail: { items: updated.items, sections: result.sections,
                source: 'inc-cart-gift', didError: false },
            }),
          }));
          ownEvent = false;
          pending = true;
        } else {
          syncControls(cart);
        }
      }
    } catch (error) {
      console.error('Oferta eBook Inconformado:', error);
      document.querySelectorAll('[data-inc-gift-status]').forEach(el => {
        el.textContent = 'Não foi possível atualizar. Tenta novamente.';
      });
    } finally {
      running = false;
      ownEvent = false;
    }
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-inc-gift-toggle]')) return;
    selected = event.target.checked;
    sessionStorage.setItem(choiceKey, selected ? 'yes' : 'no');
    reconcile();
  });
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (ownEvent) return;
    event.promise?.then(({ detail }) => {
      if (!detail?.didError && detail?.source !== 'inc-cart-gift') reconcile();
    }).catch(() => {});
  });
  window.addEventListener('pageshow', reconcile);
  reconcile();
}
